<template>
  <v-row>
    <v-col
      cols="12"
      sm="12"
      md="12"
      lg="5"
    >
      <div>
        <div
          v-if="loading"
          class="text-center"
          :style="styleObject"
        >
          <v-icon
            light
            class="custom-loader"
            :style="styleObject"
          >
            mdi-cached
          </v-icon>
          Carregando Dados...
        </div>
        <div
          v-else-if="error"
          class="alert alert-danger"
        >
          {{ error }}
        </div>
        <div
          v-if="texto"
          class="text-center"
        >
          <h4>{{ texto }}</h4><br>
        </div>
        <div v-else>
          <canvas
            id="myChartMaisVida12"
            width="100"
            height="50"
          />
        </div>
      </div>
    </v-col>
    <v-col
      cols="12"
      sm="12"
      md="12"
      lg="7"
    >
      <div>
        <div
          v-if="loading1"
          class="text-center"
          :style="styleObject"
        >
          <v-icon
            light
            class="custom-loader"
            :style="styleObject"
          >
            mdi-cached
          </v-icon>
          Carregando Dados...
        </div>
        <div
          v-else-if="error"
          class="alert alert-danger"
        >
          {{ error1 }}
        </div>
        <div
          id="idTable"
          style="overflow-x: auto; max-width: 100%;"
        >
          <table
            style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
            class="elevation-1"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('codCliente')"
                >
                  Cod. cliente
                  <v-icon small>
                    {{ ordenarPorFaturamentoCliente === 'codCliente' ? (ordenacaoDecrescenteFaturamentoCliente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('cliente')"
                >
                  Cliente
                  <v-icon small>
                    {{ ordenarPorFaturamentoCliente === 'cliente' ? (ordenacaoDecrescenteFaturamentoCliente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('nomeRede')"
                >
                  Rede
                  <v-icon small>
                    {{ ordenarPorFaturamentoCliente === 'nomeRede' ? (ordenacaoDecrescenteFaturamentoCliente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                  @click="mudarOrdenacao('mix')"
                >
                  Mix
                  <v-icon small>
                    {{ ordenarPorFaturamentoCliente === 'mix' ? (ordenacaoDecrescenteFaturamentoCliente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in dadosTabela"
                :key="item.id"
              >
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.codCliente }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.cliente }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.nomeRede }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.mix }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
  import Chart from 'chart.js'
  import MixMedio from '../../../../services/mixmedio'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardMixMedioCidade3',
    emits: ['setDadosMixMedioCidade3'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      colors: [],
      myChart: {},
      title: null,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresaSelect: [],
      cidades: [],
      redes: [],
      areas: [],
      vendedores: [],
      produtos: [],
      linhas: [],
      volume: [],
      precoMedio: [],
      clientes: [],
      segmento: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      valorExibicao: false,
      montarGrafico: true,
      loading: false,
      error: null,
      loading1: false,
      error1: null,
      headers: [
        { text: 'Cod. cliente', value: 'codCliente', align: 'left', class: 'black--text title' },
        { text: 'Cliente', value: 'cliente', align: 'left', class: 'black--text title' },
        { text: 'Rede', value: 'nomeRede', align: 'left', class: 'black--text title' },
        { text: 'Mix', value: 'mix', align: 'left', class: 'black--text title' },
      ],
      dadosTabela: [],
      enableTabela: false,
      texto: false,
      dataEnvio: '',
      quantidadeEnvio: 0,
      sortBy: '',
      sortDesc: false,
      ordenarPorFaturamentoCliente: '',
      ordenacaoDecrescenteFaturamentoCliente: false,
    }),

    created () {
      eventEmit.$on('update-form-mais-vida-cidade3', this.handleUpdateDados)

      eventEmit.$on('enable-consultas', this.enableDadosConsulta)

      eventEmit.$on('disable-tooltip-mix-cidade3', this.disableTooltipCidade3)
    },

    beforeDestroy () {
      eventEmit.$off('update-form-mais-vida-cidade3', this.handleUpdateDados)

      eventEmit.$off('enable-consultas', this.enableDadosConsulta)

      eventEmit.$off('disable-tooltip-mix-cidade3', this.disableTooltipCidade3)
    },

    methods: {
      handleUpdateDados (dataInicial, dataFinal, empresaSelect, cidadeSelect, areaSelect, vendedorSelect, redeSelect, produtoSelect, linhaSelect, clienteSelect, segmento) {
        this.dataInicial = dataInicial
        this.dataFinal = dataFinal
        this.empresaSelect = empresaSelect
        this.cidades = cidadeSelect
        this.areas = areaSelect
        this.redes = redeSelect
        this.vendedores = vendedorSelect
        this.produtos = produtoSelect
        this.linhas = linhaSelect
        this.clientes = clienteSelect
        this.segmento = segmento

        this.atualizaGrafico()
      },

      disableTooltipCidade3 () {
        this.myChart.tooltip._active = []
        this.myChart.tooltip.update()
        this.myChart.draw()
      },

      enableDadosConsulta () {
        this.dadosTabela = []
        this.enableTabela = false
        this.texto = false

        if (this.myChart.data) {
          this.myChart.destroy()
        }
      },

      async atualizaGrafico () {
        this.loading = true
        this.dadosTabela = []
        this.enableTabela = false
        this.texto = false

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await MixMedio.showGraficoMixMedioCidade(this.dataInicial, this.dataFinal, this.empresaSelect, this.produtos, this.vendedores, this.redes, this.cidades, this.areas, localStorage.tokencontrato, this.segmento).then(resposta => {
          if (resposta.data.status) {
            const ctx = document.getElementById('myChartMaisVida12').getContext('2d')

            this.myChart = new Chart(ctx, {
              type: 'line',
              data: {
                labels: resposta.data.datas,
                datasets: [
                  {
                    label: 'Faturamento',
                    data: resposta.data.dadosFaturamento,
                    backgroundColor: 'rgba(0, 123, 255, 0.5)',
                    borderColor: 'rgba(0, 123, 255, 1)',
                    order: 1,
                    fill: false,
                    tension: 0,
                  },
                ],
              },
              options: {
                scales: {
                  x: {
                    type: 'time',
                    time: {
                      unit: 'day',
                      tooltipFormat: 'YYYY-MM-DD',
                      displayFormats: {
                        day: 'YYYY-MM-DD',
                      },
                    },
                    ticks: {
                      source: 'labels',
                    },
                  },
                  y: {
                    beginAtZero: true,
                    precision: 0,
                  },
                },
                legend: {
                  display: false,
                },
                events: ['click'],
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      var d1 = tooltipItem.label
                      var quantidade = tooltipItem.yLabel

                      this.dadosTabela = []
                      this.enableTabela = false
                      this.loading1 = true

                      this.getTabela(d1, resposta.data.semanas, quantidade.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))

                      return d1 + ' - ' + quantidade.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                    },
                    title: function () {
                      return 'Mix Médio'
                    },
                  },
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.texto = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.msg === 'Data inicial nao pode ser maior que a data Final') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.texto = e.data.msg

            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.texto = e.data.text

            this.showSnackbar('error', 3000, e.data.text)
          } else if (e.data.text === 'Não há dados com os filtos selecionados') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.texto = e.data.text

            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => { this.loading = false })
      },

      getTabela (data, semanas, quantidade) {
        this.loading1 = true
        this.dataEnvio = data
        this.quantidadeEnvio = quantidade

        MixMedio.showDadosTabelaMixMedioCidade(data, semanas, this.empresaSelect, this.produtos, this.vendedores, this.redes, this.cidades, this.areas, localStorage.tokencontrato, this.segmento).then(resposta => {
          if (resposta.data.status) {
            this.enableTabela = true
            this.dadosTabela = resposta.data.dadosFaturamento.map((item) => {
              var listaTabela = ({
                codCliente: item.codCliente,
                cliente: item.cliente,
                nomeRede: item.nomeRede,
                mix: item.mix,
              })

              return listaTabela
            })

            eventEmit.$emit('set-dados-mix-medio-cidade3', data, this.dadosTabela, quantidade)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading1 = false })
      },

      mudarOrdenacao (campo) {
        if (this.ordenarPorFaturamentoCliente === campo) {
          this.ordenacaoDecrescenteFaturamentoCliente = !this.ordenacaoDecrescenteFaturamentoCliente
        } else {
          this.ordenarPorFaturamentoCliente = campo
          this.ordenacaoDecrescenteFaturamentoCliente = false
        }

        this.buscarDados()
      },

      buscarDados () {
        const novaOrdenacao = [...this.dadosTabela]

        novaOrdenacao.sort((a, b) => {
          let result = 0

          if (a[this.ordenarPorFaturamentoCliente] < b[this.ordenarPorFaturamentoCliente]) result = -1
          if (a[this.ordenarPorFaturamentoCliente] > b[this.ordenarPorFaturamentoCliente]) result = 1

          if (this.ordenacaoDecrescenteFaturamentoCliente) result *= -1

          return result
        })

        this.dadosTabela = novaOrdenacao

        eventEmit.$emit('set-dados-mix-medio-cidade3', this.dataEnvio, novaOrdenacao, this.quantidadeEnvio)
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 401px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }
</style>

<style lang="sass">
  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

  #myChartMaisVida5
    display: grid
    align-items: center
    font-weight: bold
    width: 500
    height: 330

  #textTable
    font-size: 0.75rem !important
</style>
